var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "tooltip",
          rawName: "v-tooltip",
          value: { content: _vm.userName },
          expression: "{ content: userName }"
        }
      ],
      staticClass: "user-avatar"
    },
    [_c("span", [_vm._v(_vm._s(_vm.initials))])]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }